/**
 * Seconds a resend is still on cooldown for, derived from an absolute deadline
 * rather than a running count so the value survives the step unmounting when
 * the coach steps back to the amount view.
 */
export const OTP_RESEND_COOLDOWN_SECONDS = 30;

/**
 * @param resendAvailableAt epoch ms the cooldown expires; 0 when no code sent
 * @param now epoch ms to measure against
 */
export function remainingResendSeconds(resendAvailableAt: number, now: number): number {
  if (!resendAvailableAt) {
    return 0;
  }
  return Math.max(0, Math.ceil((resendAvailableAt - now) / 1000));
}
